import { render } from "./NotifyWindow.vue?vue&type=template&id=3e7a5481&scoped=true"
import script from "./NotifyWindow.vue?vue&type=script&lang=js"
export * from "./NotifyWindow.vue?vue&type=script&lang=js"

import "./NotifyWindow.vue?vue&type=style&index=0&id=3e7a5481&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7a5481"]])

export default __exports__